/**
 * Minimal in-flight correlation for send_entity_share request_id acknowledgements.
 * Not a general WS framework — entity-share picker only.
 */

const pending = new Map();

export const ENTITY_SHARE_TRANSPORT_ERROR =
  "З'єднання недоступне. Спробуйте ще раз.";

export const ENTITY_SHARE_AMBIGUOUS_ERROR =
  "Надсилання перервано. Перевірте чат перед повторною спробою.";

export function createEntityShareRequestId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID().replace(/-/g, "");
  }
  return `es${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
}

export function registerEntityShareRequest(requestId, handlers) {
  if (!requestId || !handlers) {
    return () => {};
  }
  pending.set(requestId, handlers);
  return () => {
    const current = pending.get(requestId);
    if (current === handlers) {
      pending.delete(requestId);
    }
  };
}

export function resolveEntityShareRequest(requestId, result) {
  if (!requestId || !pending.has(requestId)) {
    return false;
  }
  const handlers = pending.get(requestId);
  pending.delete(requestId);
  if (result?.ok) {
    handlers.onSuccess?.(result);
  } else {
    handlers.onError?.(result);
  }
  return true;
}

/**
 * Fail all in-flight entity-share requests (socket close / transport loss).
 * Does not invent success; callers must surface a recoverable ambiguous error.
 */
export function failPendingEntityShareRequests(result) {
  const ids = Array.from(pending.keys());
  ids.forEach((requestId) => {
    resolveEntityShareRequest(requestId, {
      ok: false,
      detail: result?.detail || ENTITY_SHARE_AMBIGUOUS_ERROR,
      payload: result?.payload,
    });
  });
  return ids.length;
}

export function getPendingEntityShareRequestCountForTests() {
  return pending.size;
}

export function clearEntityShareRequestsForTests() {
  pending.clear();
}
